<template>
  <v-chart :options="chartOptions" :autoresize="true" class="page-trend-chart" :style="{ height: height + 'px' }" />
</template>

<script>
import ECharts from "vue-echarts/dist/vue-echarts.js";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/grid";

const COLORS = ["#5b8ff9", "#5ad8a6", "#f2637b", "#e6b600", "#9270ca", "#ff9d4d", "#269a99", "#ff99c3"];

export default {
  name: "PageTrendChart",
  components: {
    "v-chart": ECharts
  },
  props: {
    // [{ name: 'Page name', points: [{ date, count }, ...] }, ...] - series may cover different
    // sets of dates (quiet days are omitted, not zero-filled), so dates are unioned/aligned here.
    data: {
      type: Array,
      default: () => []
    },
    valueFormatter: {
      type: Function,
      default: v => String(v)
    },
    dateFormatter: {
      type: Function,
      default: v => v
    },
    height: {
      type: Number,
      default: 280
    }
  },
  computed: {
    dates() {
      const set = new Set();
      this.data.forEach(series => (series.points || []).forEach(p => set.add(p.date)));
      return Array.from(set).sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
    },
    chartOptions() {
      const dates = this.dates;
      const valueFormatter = this.valueFormatter;
      const dateFormatter = this.dateFormatter;
      const series = this.data.map(s => {
        const countByDate = {};
        (s.points || []).forEach(p => {
          countByDate[p.date] = p.count || 0;
        });
        return {
          name: s.name,
          type: "line",
          data: dates.map(d => countByDate[d] || 0),
          smooth: true,
          symbol: "circle",
          showSymbol: false,
          lineStyle: { width: 2 }
        };
      });
      return {
        color: COLORS,
        grid: { left: 52, right: 20, top: 36, bottom: 60, containLabel: false },
        legend: {
          bottom: 0,
          icon: "circle",
          itemGap: 16,
          textStyle: { color: "#606266", fontSize: 12 }
        },
        tooltip: {
          trigger: "axis",
          formatter(params) {
            if (!params.length) return "";
            const lines = params.map(p => p.marker + p.seriesName + ": " + valueFormatter(Number(p.value)));
            return dateFormatter(params[0].axisValue) + "<br/>" + lines.join("<br/>");
          }
        },
        xAxis: {
          type: "category",
          data: dates,
          boundaryGap: false,
          axisLabel: {
            formatter(v) {
              return dateFormatter(v);
            },
            color: "#9aa5b1",
            fontSize: 12
          },
          axisLine: { lineStyle: { color: "#dcdfe6" } },
          axisTick: { show: false }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter(v) {
              return valueFormatter(Number(v));
            },
            color: "#9aa5b1",
            fontSize: 12
          },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#ebeef5" } }
        },
        series
      };
    }
  }
};
</script>

<style scoped>
.page-trend-chart {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLog/PageTrendChart.vue